import React from 'react';
import { Column, Row, Stack } from '@grubhubprod/gh-cookbook-react';
import { PageSectionTitle } from 'src/components/enterprise/layout/PageSectionTitle/PageSectionTitle';
import { CorporateNameFieldControl } from 'src/components/enterprise/features/Corporate/components/Form/CorporateNameFieldControl/CorporateNameFieldControl';
import { MarketSelect } from 'src/components/enterprise/features/Corporate/components/Form/MarketSelect/MarketSelect';
import { TimeZoneControl } from 'src/components/enterprise/features/Corporate/components/Form/TimeZoneControl/TimeZoneControl';
import { BasePhoneNumberInput } from 'src/components/common/BasePhoneNumberInput/BasePhoneNumberInput';
import { SalesPersonID } from 'src/components/enterprise/features/Corporate/components/Form/SalesPersonID/SalesPersonID';
import { ExpenseCode } from 'src/components/enterprise/features/Corporate/components/Form/ExpenseCode/ExpenseCode';
import { BrandOptions } from 'src/components/enterprise/features/Corporate/components/Form/BrandOptions/BrandOptions';
import { useCorporateFormContext } from 'src/components/enterprise/features/Corporate/components/Form/CorporateFormProvider/useCorporateFormContext';
import { FirmIdField } from 'src/components/enterprise/features/Corporate/components/Form/FirmIdField/FirmIdField';
import { EffectiveDateControl } from 'src/components/enterprise/features/Corporate/components/Form/EffectiveDateControl/EffectiveDateControl';
import { ChildCorpNameFieldControl } from 'src/components/enterprise/features/Corporate/components/Form/ChildCorpNameFieldControl/ChildCorpNameFieldControl';
import { FirstOrderDate } from 'src/components/enterprise/features/Corporate/components/Form/FirstOrderDate/FirstOrderDate';
import { withRequiredForAutoInvoicing } from 'src/components/enterprise/features/Corporate/components/Form/withRequiredForAutoInvoicing/withRequiredForAutoInvoicing';
import PageSection from 'src/components/enterprise/layout/PageSection';

export const TimeZone = withRequiredForAutoInvoicing(
  TimeZoneControl,
  'Time Zone is required'
);

export const FirmInformationSection: React.FC = () => {
  const { isEditPage, isChildPage, corpData } = useCorporateFormContext();

  const hasFirstOrderDate = corpData?.firstOrderDate;

  return (
    <Stack y="md">
      <PageSection>
        <Row>
          <Column phone={10}>
            <Stack y="sm">
              <PageSectionTitle
                title={
                  isChildPage ? 'Child Firm Information' : 'Firm Information'
                }
              />
            </Stack>
            <Row gutter={12}>
              <Column phone={6} gutter={12}>
                <Stack y="sm">
                  {isChildPage ? (
                    <ChildCorpNameFieldControl name="name" id="name-id" />
                  ) : (
                    <CorporateNameFieldControl name="name" id="name-id" />
                  )}
                </Stack>
              </Column>
              {isEditPage && (
                <Column phone={2} gutter={12}>
                  <Stack y="sm">
                    <FirmIdField name="clientId" id="clientId" />
                  </Stack>
                </Column>
              )}
            </Row>
            <Row gutter={12}>
              <Column phone={6} gutter={12}>
                <Stack y="sm">
                  <MarketSelect name="markets" id="corp-market" />
                </Stack>
              </Column>
              <Column phone={6} gutter={12}>
                <Stack y="sm">
                  <TimeZone name="invoiceTimeZone" id="timezone" />
                </Stack>
              </Column>
            </Row>
            <Row gutter={12}>
              <Column phone={6} gutter={12}>
                <Stack y="sm">
                  <BasePhoneNumberInput
                    name="phoneNumber"
                    id="corp-phone-number"
                  />
                </Stack>
              </Column>
            </Row>
            {hasFirstOrderDate && (
              <Row gutter={12}>
                <Column phone={6} gutter={12}>
                  <Stack y="sm">
                    <FirstOrderDate name="firstOrderDate" />
                  </Stack>
                </Column>
              </Row>
            )}
            <Row gutter={12}>
              <Column phone={6} gutter={12}>
                <Stack y="sm">
                  <SalesPersonID name="salesPersonCode" id="sales-person-id" />
                </Stack>
              </Column>
              <Column phone={6} gutter={12}>
                <Stack y="sm">
                  <EffectiveDateControl
                    name="effectiveDate"
                    id="effective-date"
                  />
                </Stack>
              </Column>
            </Row>
            <Row gutter={12}>
              <Column phone={6} gutter={12}>
                <Stack y="sm">
                  <ExpenseCode
                    name="expenseCodeAliasSingular"
                    id="expense-code"
                  />
                </Stack>
              </Column>
            </Row>
            <Row gutter={12}>
              <Column phone={6} gutter={12}>
                <BrandOptions id="brand" name="brand" />
              </Column>
            </Row>
          </Column>
        </Row>
      </PageSection>
    </Stack>
  );
};
